<template>
  <base-slide-over ref="filterSlideover" title="Filter Patients" size="lg">
    <base-form ref="form" class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" @submit.prevent>
      <div class="tw-text-normal tw-font-normal tw-mb-2.5 tw-mt-6">State</div>
      <base-advanced-select label="State" placeholder="Select one or more states" :options="statesOptions" v-model="statesFilter" label-key="name" multiple />

      <div class="tw-text-normal tw-font-normal tw-mt-5 tw-mb-2.5">Locations</div>
      <base-advanced-select placeholder="Select location(s)" :options="orderedLocations" label-key="name" value-key="businessLocationId" multiple v-model="locationsFilter" />
    </base-form>
    <template #fixed-bottom>
      <div class="tw-p-3 tw-flex tw-justify-between">
        <base-button type="flat" color="red" class="tw-w-auto tw-mr-2" @click="clearFilters">
          Clear All
        </base-button>
        <div>
          <base-button type="flat" class="tw-w-auto tw-mr-2" @click="$refs.filterSlideover.hide()">
            Cancel
          </base-button>
          <base-button class="tw-w-auto" @click="applyFilter">
            Apply
          </base-button>
        </div>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import { STATE_OPTIONS } from "@/constants/constants";

import { mapGetters } from "vuex";

export default {
  name: "FilterSlideover",
  props: {
    businessId: { type: String },
  },
  components: {},
  data() {
    return {
      itemTypes: [],
      statesFilter: [],
      statesOptions: STATE_OPTIONS,
      locationsFilter: [],
    };
  },
  computed: {
    ...mapGetters("location", ["locations"]),
    orderedLocations() {
      return this.locations.slice().sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
    },
  },
  created() {},
  methods: {
    show() {
      this.$refs.filterSlideover.show();
    },
    hide() {
      this.$refs.filterSlideover.hide();
    },
    clearFilters() {
      this.reset();
      this.applyFilter();
    },
    reset() {
      this.locationsFilter = [];
      this.statesFilter = [];
    },
    applyFilter() {
      this.$emit("filter-updated", {
        locationsFilter: this.locationsFilter.map((x) => x.businessLocationId),
        statesFilter: this.statesFilter.map((state) => state.value),
      });

      this.hide();
    },
  },
};
</script>
